// @flow

import { RestClientAuthenticated } from '../network';
import { turanBaseURL } from '../../utils/urlUtils';

const marketingApi = {
  fetch: () => new RestClientAuthenticated(`${turanBaseURL()}/marketing`, 'GET').execute(),
  getKeyFigures: (pcId: number) => new RestClientAuthenticated(`${turanBaseURL()}/marketing/shopping-centers/${pcId}/key-figures`, 'GET').execute(),
  getDominantCustomerProfile: (pcId: string) => new RestClientAuthenticated(`${turanBaseURL()}/marketing/shopping-centers/${pcId}/dominant`, 'GET').execute(),
  getMonthlyLoyaltySurvey: (pcCode: string) => new RestClientAuthenticated(`${turanBaseURL()}/marketing/shopping-centers/${pcCode}/monthly-survey`, 'GET').execute(),
  fetchWeightedSpend: (pcId: string) =>
    new RestClientAuthenticated(`${turanBaseURL()}/marketing/shopping-centers/${pcId}/weighted-spend`, 'GET').execute(),
  fetchMarketingCameoGroups: (pcId: number) =>
    new RestClientAuthenticated(`${turanBaseURL()}/marketing/shopping-centers/${pcId}/cameo-groups`, 'GET').execute(),
  fetchCentreTradeAreas: (pcId: number) =>
    new RestClientAuthenticated(`${turanBaseURL()}/marketing/shopping-centers/${pcId}/center-trade-areas`, 'GET').execute(),
};

export default marketingApi;
